export function createLinks(
    { communityStoriesLink, takeActionLink, colour },
    options
) {
    const linkLabel = {
        h: 'h-0-1/4',
        font: { colour, weight: 'bold' },
        text: 'Take Action'
    };
    const links = {
        font: { style: 'italic' },
        y: 'h-0-1/4',
        communityStories: communityStoriesLink && {
            h: 'h-0-1/2',
            label: {
                ...linkLabel,
                text: 'Get Inspired'
            },
            desc: {
                position: 'parent',
                x: 56,
                text: 'by community stories, visit:'
            },
            link: {
                font: { colour },
                href: `${communityStoriesLink}`,
                text: `${communityStoriesLink.replace('https://', '')}`,
            }
        },
        takeAction: takeActionLink && {
            y: 'h-0-1/8',
            linkLabel,
            linkDesc: {
                position: 'parent',
                text: 'in your community using strategies',
                x: 56,
            },
            linkDesc2: {
                text: 'available at:'
            },
            link: {
                position: 'parent',
                y: linkLabel.h,
                font: { colour },
                text: `${takeActionLink.replace('https://', '')}`,
                href: `${takeActionLink}`,
                x: 54
            }
        },
        ...options
    };
    // console.log('TODO: Replace new with old', old);
    return links;
    // return {
    //     h: 100,
    //     text: 'Links',
    //     border: { colour }
    // };
}

export default ({ communityStoriesLink, takeActionLink, colorClass: colour }, options) => {
    if (communityStoriesLink || takeActionLink) {
        return createLinks({ communityStoriesLink, takeActionLink, colour }, options);
    }
    return null;
};
